import React from 'react'

import { Form, FormikProvider, useFormik } from 'formik'
import type { FC } from 'react'
import * as Yup from 'yup'

import { Button } from '@/components/ui/button'
import { DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

import { DEFAULT_GLOBAL_VIEWS_NAME } from '.'

export interface ViewFormValues {
	name: string
}

interface Props {
	onSave: (values: ViewFormValues) => void
	onClose: () => void
	name?: string
	isAdmin: boolean
}

const ViewsForm: FC<Props> = ({ onSave, onClose, name = '', isAdmin }) => {
	const formik = useFormik({
		initialValues: {
			name,
		},
		enableReinitialize: true,
		validationSchema: Yup.object().shape({
			name: Yup.string().max(255).required('Name is required'),
		}),
		onSubmit: (values, { setSubmitting }) => {
			onSave(values)
			setSubmitting(false)
		},
	})

	const {
		errors,
		touched,
		handleSubmit,
		isSubmitting,
		getFieldProps,
		setFieldValue,
		values,
	} = formik

	return (
		<FormikProvider value={formik}>
			<Form autoComplete="off" noValidate onSubmit={handleSubmit}>
				<DialogHeader>
					<DialogTitle>Save view as...</DialogTitle>
				</DialogHeader>
				<div className="space-y-4 mt-4">
					<div className="grid w-full items-center gap-1.5">
						<Label htmlFor="view-name">Name</Label>
						<Input
							id="view-name"
							name="name"
							placeholder="Enter View Name"
							value={values.name}
							onBlur={getFieldProps('name').onBlur}
							onChange={e =>
								setFieldValue('name', e.target.value)
							}
							disabled={isSubmitting}
						/>
						{touched.name && errors.name && (
							<p className="text-sm text-destructive">
								{errors.name}
							</p>
						)}
					</div>
				</div>

				<div className="mt-6 flex justify-end gap-2">
					<Button
						type="button"
						variant="outline"
						onClick={onClose}
						disabled={isSubmitting}
					>
						Cancel
					</Button>
					<Button
						type="submit"
						disabled={
							(!isAdmin &&
								values.name === DEFAULT_GLOBAL_VIEWS_NAME) ||
							isSubmitting
						}
					>
						Save
					</Button>
				</div>
			</Form>
		</FormikProvider>
	)
}

export default ViewsForm
